// Package Block
import { Row, Col, Spin } from "antd";
import { shallowEqual, useSelector } from "react-redux";

// Custom Block & Function Component
import { TilesWidget } from "../common/TileWidget";
import { formatAndShortCurrency, formatAndShortNumber, getSettingKey } from "../../../../Common/utils";
import { hasPermissions, Permission } from "../../../../Common/constants";
import { useDashboardBalanceVisibility } from "../balanceVisibility";

const data = {
  paid_amounts: {
    icon: "/media/svg/icons/Shopping/coin-stack.svg",
    title: "Paid Amount",
    iconColor: "success",
    url: "/reporting/financial-reporting/payment-received-report",
  },
  payable_amount: {
    icon: "/media/svg/icons/Shopping/payable-amount.svg",
    title: "Payable Amount",
    iconColor: "info",
    url: "/reporting/financial-reporting/account-payable-report",
  },
  receivable_amount: {
    icon: "/media/svg/icons/Shopping/money-filled.svg",
    title: "Receivable Amount",
    iconColor: "primary",
    url: "/reporting/financial-reporting/account-receivable-report",
  },
  total_delivery_orders: {
    icon: "/media/svg/icons/Shopping/delivery-truck.svg",
    title: "Delivery Orders",
    iconColor: "danger",
    url: "/sale/fulfillment",
  },
  total_pickup_orders: {
    icon: "/media/svg/icons/Shopping/cart-latest.svg",
    title: "Pickup Orders",
    iconColor: "dark",
    url: "/sale/fulfillment",
  },
  total_sales: {
    icon: "/media/svg/icons/Shopping/money-bag-filled.svg",
    title: "Total Sale/Revenue",
    iconColor: "warning",
    url: "/reporting/purchasing-inventory/sales/sales-summary",
  },
};

export default function ({ loading, stats }) {
  const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
  const currencySymbol = getSettingKey(currentState.entity, "Basic", "currency_symbol");
  const hasDashboardPermission = hasPermissions([Permission.DashboardView])[0];
  const { formatCurrencyValue } = useDashboardBalanceVisibility();

  const serverData = {
    total_sales: formatCurrencyValue(stats?.total_sales, currencySymbol, (amount) => formatAndShortCurrency(amount).toUpperCase()),
    paid_amounts: formatCurrencyValue(stats?.paid_amounts, currencySymbol, (amount) => formatAndShortCurrency(amount).toUpperCase()),
    payable_amount: formatCurrencyValue(stats?.payable_amount, currencySymbol, (amount) => formatAndShortCurrency(amount).toUpperCase()),
    receivable_amount: formatCurrencyValue(stats?.receivable_amount, currencySymbol, (amount) => formatAndShortCurrency(amount).toUpperCase()),
    total_delivery_orders: !stats?.total_delivery_orders ? 0 : formatAndShortNumber(stats?.total_delivery_orders).toUpperCase(),
    total_pickup_orders: !stats?.total_pickup_orders ? 0 : formatAndShortNumber(stats?.total_pickup_orders).toUpperCase(),
  };

  return (
    <div className="w-100">
      <Spin spinning={loading}>
        {hasDashboardPermission && (
          <Row gutter={[10, 10]}>
            {Object.keys(serverData).map((key) => (
              <Col span={12} lg={8} key={key}>
                <TilesWidget data={data[key]} value={serverData[key]} />
              </Col>
            ))}
          </Row>
        )}
      </Spin>
    </div>
  );
}
